import { Link } from "react-router-dom";
import { Icon } from "../../components/core/Icon";
import styles from "../../../styles/brands.module.scss";

export const BrandCard = ({ brand }) => {
    return (
        <Link to={`/configuracoes/unidade/${brand.id}`}>
            <div className={styles.brand}>
                <div className="d-flex">
                    <div className={styles.logo}>
                        {brand.avatarUrl ? (
                            <img
                                src={process.env.REACT_APP_ASSETS_URL + `/` + brand.avatarUrl}
                                alt={brand.name}
                            />
                        ) : (
                            <Icon name="image-polaroid" size="2x" light />
                        )}
                    </div>
                    <div className="d-flex flex-column align-start">
                        <p className={styles.name}>{brand.name}</p>
                        <span className={styles.units}>
                            {brand.units} unidades
                        </span>
                    </div>
                </div>
                <Icon name="chevron-right" />
            </div>
        </Link>
    )
}